import React from 'react'

import { connect } from 'react-redux';

import moment from 'moment';
import { Card, CardBlock, CardTitle , Button , Dropdown , DropdownToggle, 
  DropdownMenu, DropdownItem,Input
} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";

import * as actions from  '../../../actions/factura';

import _ from "lodash";

import {API_URL,api}  from '../../../actions/_request';
import Menu from '../menu.js';

// import ModalInventario from './inventarioFisicoModal.js'
// import ModalHistoricos from './inventarioFisicoHistoricos.js'

import IconEdit from 'react-icons/lib/md/edit';
import IconPrint from 'react-icons/lib/fa/print';
import IconForms from 'react-icons/lib/fa/wpforms';
import IconTimbrar from 'react-icons/lib/fa/check-square-o';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import IconBan from "react-icons/lib/fa/ban";
import IconsNote  from "react-icons/lib/fa/paperclip";

import IconList from 'react-icons/lib/fa/list-alt';

import IconHistorico from 'react-icons/lib/fa/archive';

import swal from 'sweetalert2';
import ModalCorreo from '../../../components/facturarTicket/ModalCorreo';
import ModalNota from '../../../components/facturarTicket/ModalNota';
import ModalReportes from '../../../components/facturarTicket/ModalReportes';

const filterCaseInsensitive = (filter, row) => {
            const id = filter.pivotId || filter.id;
            if (row[id] !== null){
                return (
                    row[id] !== undefined ?
                        String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
                        :
                        true
                );
            }
        };

class InvoiceModule extends React.Component{
  constructor(props) {
        super(props);
        this.state = {
          fecha : moment().format('Y-MM-DD'),
          forma_pago:0,
          tipo:0,

            modal       : false,
            prospectoid : null,
            title       : "",
            modalHistoricos : false,
            data: [],
            pages: null,
            loading: true,

            seleccion_id : '',             
            kardexModal : false,
            opcionConsulta : 0,
            modal_reportes:false,
            consulta:0,

            modal_correo:false,
            modal_nota:false,
            factura:0,
            cliente:0,
            filtro:0,
            recargar:false,
        };
      
     
        



        this.toggle_correo  = this.toggle_correo.bind(this);

        this.recargar2 = this.recargar2.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }

    handleInputChange(event) {

        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;
        
        this.setState({
            [name] : value,
            recargar:false,
            data:[],
             loading:true,
        });
    }

    handleSelectChange(select, name,tipo=0) {;
      let value=null;
        if(tipo==0){
           value = select === null ? null : select.target.value;
        }else{
           value = select === null ? null : select.value;
        }
     
        this.setState({[name] : value,
                        recargar:false,
                        data:[],
                         loading:true,
                      });

    }
     recargar2(){
      let self=this;
      api().get(`/reporte/facturas_dia?fecha=${this.state.fecha}&pago=${this.state.forma_pago}&tipo=${this.state.tipo}`)
        .then(function(response)
        {
            self.setState({
                 data : response.data,
                 recargar:true,
                 loading:false,
            });
            // console.log(response.data)
        });
    }

    toggle_correo(evt=[],factura=[]){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_correo : !this.state.modal_correo, 
              factura : factura.value,
              cliente : factura.cliente_id,
          });
    }
 
    


   

    render(){
      let permisos_modulos= this.props.auth.permisos[6];
      // console.log('permisos--->',permisos_modulos);
      
      const { data, pages, loading ,recargar} = this.state;
      // console.log(this.props.inventarioFisico.data)
      if(recargar==false)
          setTimeout(this.recargar2() , 3);
      return(

        <div className="view">
              <Menu props={this.props}/>
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Lista de Facturas Del Dia </h1>
                    </header>
                </div>
              <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                            <div className="row">
                            <div className="col-md-2"> </div>
                            <div className="col-md-2">
                            <div className="form-group">
                                <label className>Fecha *:</label>
                                <input
                                    type="date" 
                                    className="form-control"
                                    name="fecha"
                                    value={this.state.fecha || ''}
                                    onChange={this.handleInputChange}
                                   
                                />
                            </div>
                        </div>
                            <div className="col-md-3"> 
                            <div className="form-group">
                            <label className> Forma de Pago *:</label>
                            <Input type="select" 
                            name="forma_pago" 
                            id="forma_pago" 
                            value={this.state.forma_pago} 
                            onChange={(e) => this.handleSelectChange(e,'forma_pago')} >
                            <option value={0}>Contado</option>
                            <option value={1}>Credito</option>
   

                            </Input>
                            </div>
                            </div>
                            <div className="col-md-3"> 
                            <div className="form-group">
                            <label className>Tipo *:</label>
                            <Input type="select" 
                            name="tipo" 
                            id="tipo" 
                            value={this.state.tipo} 
                            onChange={(e) => this.handleSelectChange(e,'tipo')} >
                            <option value={0}>Todas</option>
                            <option value={1}>Tienda</option>
                            <option value={2}>Sitio</option>
                            <option value={3}>Remoto</option>
                            <option value={4}>Venta</option>

                            </Input>
                            </div>
                            </div>
                            </div>
                          <ReactTable

                              className = "-striped -highlight"
                              columns   = {[
                               {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                     maxWidth:100,
                                    minWidth:100, 
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                 {(parseInt(row.original.tipo_doc)==1&&parseInt(row.original.importada)==0&&parseInt(row.original.timbrado)==1)&&
                                                  <a href={API_URL+"/pdf_factura/"+row.original.value+'/I'} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Facturar" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                }
                                                {(parseInt(row.original.tipo_doc)==2&&parseInt(row.original.importada)==0)&&
                                                  <a href={API_URL+"/pdf_remision/"+row.original.value} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Remision" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                }
                                               
                                           
                                              {(parseInt(row.original.tipo_doc)==1&&parseInt(row.original.importada)==0&&parseInt(row.original.timbrado)==1)&&
                                                <Button color={parseInt(row.original.enviada)==1?"info":"secondary"}
                                                 title=" Enviar Facturar"
                                                 onClick={(evt)=>this.toggle_correo(evt, row.original)}>
                                                  <FaEnvelopeO />
                                                </Button>

                                              }
                                            </div>
                                        )
                                    }
                                },
                               {Header: 'Estado', accessor: 'estado',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Factura', accessor: 'factura',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Cliente', accessor: 'cliente'},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Saldo', accessor: 'saldo' ,maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                
                              
                              ]}
                            
                              
                              data={this.state.data}
                              
                              loading={loading} // Display the loading overlay when we need it
                              defaultFilterMethod={filterCaseInsensitive}
                              filterable
                              defaultPageSize={10} 
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>
                                            <CardTitle className="h6 text-uppercase mb-4">Más Información</CardTitle>
                                            <div className='row'>
                                              <div className='col-12'>
                                                <h1 className="h4 text-uppercase">Nota:</h1>
                                              </div>
                                              <div className='col-12'>
                                                <p className=" text-uppercase">{row.original.nota_interna} </p>
                                              </div>
                                            </div> 
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Ticket</th>
                                                  <th>Codigo</th>
                                                  <th>Descripción</th> 
                                                  <th>Cantidad</th>
                                                  <th>Total</th>                                                 
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.productos.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.clave_ticket}</td>
                                                   <td>{item.codigo_item}</td>
                                                   <td>{item.descripcion_item}</td>
                                                   <td>{item.cantidad}</td>
                                                   <td>{item.total}</td>  
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                             
                            />
                          
                        </CardBlock>
                    </Card>
                </div>
                { this.state.modal_correo&&
                    <ModalCorreo
                        open={this.state.modal_correo}
                        toggle={this.toggle_correo}  
                        cliente={this.state.cliente} 
                        factura={this.state.factura}
                    />
                }
            </div>

      )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        factura : state.factura,
        auth:state.auth,
    }
};
export default connect(mapStateToProps, actions)(InvoiceModule)


// WEBPACK FOOTER //
// ./src/views/facturacion/invoiceModule/FacturasDia.js